
let final_list={
    "data":[
       
        {
            "headTitle1": "Pledge Signing",
            "headTitle2": "",
            "type": "headtitle"
        },

        {
            "path": "/admin/pledge-signing",
            "title": "Pledge Signing",
            "icon": "disc",
            "type": "link"
        },


        {
            "headTitle1": "Submitted Contents",
            "headTitle2": "",
            "type": "headtitle"
        },

        {
            "path": "/admin/submitted-contents",
            "title": "Submitted Contents",
            "icon": "disc",
            "type": "link"
        },


        {
            "headTitle1": "Marathon",
            "headTitle2": "",
            "type": "headtitle"
        },

        {
            "path": "/admin/marathon",
            "title": "Marathon",
            "icon": "disc",
            "type": "link"
        },

        {
            "headTitle1": "Announcement",
            "headTitle2": "",
            "type": "headtitle"
        },

        {
            "path": "/admin/announcement",
            "title": "Announcement",
            "icon": "disc",
            "type": "link"
        },
        
    ]
}






export default final_list
